module.exports = __webpack_public_path__ + "img/3U3.305533a2.png";